type SectionHeadingProps = {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
};

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b border-background-200/70 pb-4">
      <div className="flex items-start gap-4">
        <span className="pt-1 font-heading text-sm font-black text-primary-500">{index}</span>
        <div>
          <p className="text-xs font-medium tracking-[0.25em] text-foreground-500 uppercase">
            {eyebrow}
          </p>
          <h2 className="mt-1.5 font-heading text-2xl font-black text-foreground-950 md:text-[28px]">
            {title}
          </h2>
          {desc && <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{desc}</p>}
        </div>
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="group inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line text-base transition-transform group-hover:translate-x-0.5"></i>
        </a>
      )}
    </div>
  );
}